import "core-js/modules/es.function.name.js";
import jwt from "jsonwebtoken";
import { getRefreshToken } from "@/js/http/auth.js";
var PARAM_NAME = "newsletter";
export function handleNewsletter(to, from, next) {
  if (to.query.from === PARAM_NAME && to.name !== "login") {
    var token = jwt.decode(getRefreshToken());
    var valid = (token === null || token === void 0 ? void 0 : token.exp) > Math.floor(Date.now() / 1000);
    if (valid && localStorage.hasOwnProperty("refresh_token")) {
      var redirect = from.query.redirect;
      if (redirect) next(redirect);else next();
    } else {
      next({
        name: "login",
        query: {
          redirect: "".concat(to.path)
        }
      });
    }
  } else next();
}